import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-credit-card-icon',
  templateUrl: './shopping-credit-card.component.html'
})
export class ShoppingCreditCardComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
